var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSinDespacho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 238,
    height: 238,
    viewBox: "0 0 238 238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F3F7FF",
    d: "M184.055 168.359l-117.099 2.044c-5.454.095-9.953-4.25-10.048-9.706-.095-5.456 4.25-9.956 9.703-10.05l-55.022.96c-5.454.095-9.953-4.25-10.048-9.706-.095-5.456 4.25-9.956 9.703-10.05l56.433-.986c5.455-.095 9.799-4.595 9.704-10.05-.096-5.456-4.594-9.801-10.049-9.706l-35.27.615c-5.454.096-9.953-4.25-10.048-9.705-.096-5.456 4.249-9.956 9.703-10.051l56.433-.985c-5.454.095-9.953-4.25-10.048-9.706-.095-5.456 4.249-9.955 9.703-10.05l138.26-2.414c5.455-.095 9.954 4.25 10.05 9.706.094 5.456-4.25 9.955-9.704 10.05l-56.433.986c5.454-.096 9.953 4.25 10.048 9.705.095 5.456-4.25 9.956-9.703 10.051l31.038-.542c5.454-.095 9.953 4.25 10.048 9.706.095 5.456-4.25 9.955-9.703 10.05l-14.354.251c-6.877.12-12.375 4.64-12.28 10.096.064 3.637 2.943 6.88 8.638 9.73 5.454-.095 9.953 4.25 10.048 9.706.095 5.456-4.25 9.955-9.703 10.05zm43.045-40.277c-5.454.096-9.952-4.25-10.048-9.705-.095-5.456 4.25-9.956 9.704-10.051 5.454-.095 9.953 4.25 10.048 9.706.095 5.455-4.25 9.955-9.704 10.05z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43 59)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFDFF",
    d: "M107.71 104.271a.59.59 0 0 1-.59-.587V41.046a.59.59 0 0 1 .59-.587h27.42c4.452.009 8.51 2.545 10.446 6.531l8.108 16.447a11.316 11.316 0 0 1 1.181 5.098v29.487c-.025 3.45-2.84 6.237-6.31 6.25H107.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A90E2",
    fillRule: "nonzero",
    stroke: "#B7CFFC",
    strokeWidth: 2.1,
    d: "M135.13 41.046a11.14 11.14 0 0 1 9.926 6.156l8.108 16.235a10.754 10.754 0 0 1 1.11 4.84v29.745c-.012 3.13-2.57 5.662-5.72 5.662h-40.843V41.046h27.418zm0-1.175h-27.42c-.652 0-1.18.526-1.18 1.175v62.638c0 .649.528 1.175 1.18 1.175h40.845c3.788-.013 6.863-3.048 6.901-6.814V68.347a11.994 11.994 0 0 0-1.252-5.38l-8.084-16.306c-2.083-4.132-6.34-6.736-10.99-6.72v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A90E2",
    d: "M119.056 75.584a3.178 3.178 0 0 1-2.277-.889 3.14 3.14 0 0 1-.96-2.236V52.277c-.007-.831.322-1.63.913-2.217a3.13 3.13 0 0 1 2.23-.908h16.096c1.1-.014 2.106.61 2.577 1.598l7.752 15.647c.417.833.635 1.75.638 2.679v3.9a2.616 2.616 0 0 1-2.623 2.608h-24.346z",
    opacity: 0.136
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A90E2",
    fillRule: "nonzero",
    d: "M135.13 49.74a2.176 2.176 0 0 1 2.032 1.268l7.776 15.648c.353.735.546 1.535.567 2.35v3.9a1.99 1.99 0 0 1-.588 1.435c-.382.38-.903.591-1.444.585h-24.417a2.569 2.569 0 0 1-2.576-2.537V52.277a2.545 2.545 0 0 1 2.553-2.538h16.096zm0-1.176h-16.097c-2.063 0-3.735 1.662-3.735 3.713v20.182c.013 2.054 1.692 3.712 3.758 3.712h24.417a3.205 3.205 0 0 0 3.214-3.195v-3.9a6.85 6.85 0 0 0-.685-2.937l-7.777-15.648a3.43 3.43 0 0 0-3.096-1.927z",
    opacity: 0.136
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#D3E2FE",
    strokeWidth: 1.1,
    d: "M5.507 104.248c-2.715 0-4.916-2.188-4.916-4.887V88.295a.59.59 0 0 1 .59-.588h106.53a.59.59 0 0 1 .59.588v15.366a.59.59 0 0 1-.59.587H5.507z",
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B7CFFC",
    strokeWidth: 1.3,
    d: "M107.71 88.295v15.366H5.508a4.315 4.315 0 0 1-3.065-1.253 4.263 4.263 0 0 1-1.26-3.047V88.295H107.71zm0-1.175H1.183C.529 87.12 0 87.646 0 88.295V99.36c0 3.023 2.466 5.474 5.507 5.474h102.204c.653 0 1.182-.526 1.182-1.174V88.295c0-.649-.53-1.175-1.182-1.175z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.7,
    cy: 103.684,
    fill: "#F1F5FC",
    stroke: "#B7CFFC",
    strokeWidth: 3.2,
    rx: 16.049,
    ry: 15.953
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0E0FF",
    fillRule: "nonzero",
    d: "M128.7 88.318c6.266-.01 11.92 3.737 14.322 9.49a15.322 15.322 0 0 1-3.351 16.781 15.55 15.55 0 0 1-16.883 3.332c-5.787-2.388-9.556-8.008-9.546-14.237 0-8.486 6.92-15.366 15.458-15.366zm0-1.175c-9.138 0-16.545 7.364-16.545 16.447 0 9.083 7.407 16.447 16.545 16.447 9.138 0 16.545-7.364 16.545-16.447-.064-9.056-7.434-16.382-16.545-16.447z",
    opacity: 0.136
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7CFFC",
    fillRule: "nonzero",
    stroke: "#B7CFFC",
    strokeWidth: 2,
    d: "M128.7 97.364c2.572 0 4.89 1.54 5.874 3.901a6.293 6.293 0 0 1-1.378 6.888 6.386 6.386 0 0 1-6.93 1.37 6.32 6.32 0 0 1-3.924-5.839c.013-3.485 2.852-6.307 6.358-6.32zm0-1.175c-4.161.013-7.525 3.374-7.516 7.51.008 4.137 3.386 7.484 7.547 7.48 4.162-.004 7.533-3.359 7.533-7.495a7.472 7.472 0 0 0-2.217-5.308 7.563 7.563 0 0 0-5.347-2.187z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5C6ED",
    d: "M5.91 99.361V88.295H1.181V99.36a4.263 4.263 0 0 0 1.26 3.047 4.315 4.315 0 0 0 3.065 1.253h4.728a4.315 4.315 0 0 1-3.066-1.253 4.263 4.263 0 0 1-1.26-3.047z",
    opacity: 0.136
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#B7CFFC",
    strokeWidth: 3.2,
    d: "M1.182 88.882a.59.59 0 0 1-.591-.587V8.41c0-4.052 3.298-7.34 7.374-7.354h92.986c4.077.013 7.374 3.302 7.374 7.354v79.884a.59.59 0 0 1-.59.587H1.182z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFDFFF",
    fillRule: "nonzero",
    stroke: "#B7CFFC",
    strokeWidth: 3.1,
    d: "M100.95 1.598c3.747 0 6.785 3.019 6.785 6.743v79.883H1.182V8.341c0-3.724 3.037-6.743 6.783-6.743h92.986zm0-1.175H7.966a7.99 7.99 0 0 0-5.632 2.319A7.894 7.894 0 0 0 0 8.341v79.883c0 .65.53 1.175 1.182 1.175H107.71a1.226 1.226 0 0 0 1.205-1.175V8.341c0-4.373-3.566-7.918-7.965-7.918z",
    opacity: 0.136
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A90E2",
    d: "M64.645 40.153c-.41 0-.815-.097-1.181-.282L52.85 34.397a1.282 1.282 0 0 0-.638-.165 1.187 1.187 0 0 0-.638.165l-10.637 5.545c-.365.187-.77.284-1.182.282a2.632 2.632 0 0 1-1.772-.705 2.53 2.53 0 0 1-.804-1.856V1.574a.59.59 0 0 1 .59-.587h28.86a.59.59 0 0 1 .592.587v36.018a2.569 2.569 0 0 1-2.577 2.561z",
    opacity: 0.136
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A90E2",
    fillRule: "nonzero",
    d: "M66.63 1.598v35.994a1.98 1.98 0 0 1-1.985 1.974c-.311 0-.619-.073-.898-.212L53.111 33.88a1.781 1.781 0 0 0-.898-.235 1.805 1.805 0 0 0-.922.235l-10.613 5.474c-.288.137-.602.21-.922.212a1.98 1.98 0 0 1-1.938-1.974V1.598h28.813zm0-1.175H37.819c-.653 0-1.182.526-1.182 1.175v35.994a3.158 3.158 0 0 0 3.168 3.149 3.04 3.04 0 0 0 1.441-.353l10.637-5.474a.69.69 0 0 1 .378 0 .666.666 0 0 1 .355 0l10.636 5.474c.445.232.94.353 1.442.353a3.158 3.158 0 0 0 3.12-3.149V1.598c0-.65-.53-1.175-1.182-1.175z",
    opacity: 0.136
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A90E2",
    d: "M32.925 66.562H8.816c-.77 0-1.394.62-1.394 1.386-.007.37.138.726.401.987.263.262.622.406.993.4h24.11c.77 0 1.394-.621 1.394-1.387a1.39 1.39 0 0 0-1.395-1.386zM32.925 75.184H8.816a1.413 1.413 0 0 0-1.235 1.398c0 .709.529 1.307 1.235 1.398h24.11c.545.07 1.083-.18 1.379-.64a1.403 1.403 0 0 0 0-1.514 1.421 1.421 0 0 0-1.38-.642z",
    opacity: 0.136
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A1C5EE",
    d: "M12.693 1.598H7.965c-3.746 0-6.783 3.019-6.783 6.743v79.883h4.727V8.341c0-3.724 3.037-6.743 6.784-6.743z",
    opacity: 0.136
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.298,
    cy: 103.684,
    fill: "#F1F5FC",
    stroke: "#B7CFFC",
    strokeWidth: 3.2,
    rx: 16.049,
    ry: 15.953
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFDFFF",
    fillRule: "nonzero",
    d: "M24.298 88.318c6.264 0 11.91 3.752 14.306 9.506a15.322 15.322 0 0 1-3.367 16.774 15.55 15.55 0 0 1-16.88 3.32c-5.784-2.389-9.55-8.007-9.54-14.234a15.32 15.32 0 0 1 4.535-10.874 15.506 15.506 0 0 1 10.946-4.492zm0-1.175c-9.138 0-16.545 7.364-16.545 16.447 0 9.083 7.407 16.447 16.545 16.447 9.138 0 16.546-7.364 16.546-16.447-.065-9.056-7.435-16.382-16.546-16.447z",
    opacity: 0.136
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7CFFC",
    fillRule: "nonzero",
    stroke: "#B7CFFC",
    strokeWidth: 2,
    d: "M24.298 97.364c3.509.013 6.343 2.848 6.335 6.336-.009 3.487-2.858 6.309-6.366 6.304-3.509-.004-6.35-2.832-6.35-6.32.012-3.494 2.866-6.32 6.381-6.32zm0-1.175c-4.164 0-7.54 3.356-7.54 7.495 0 4.14 3.376 7.495 7.54 7.495s7.54-3.356 7.54-7.495c-.013-4.134-3.381-7.482-7.54-7.495z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A90E2",
    d: "M42.545 37.592V1.598h-4.727v35.994c.009.688.372 1.323.963 1.681a2.02 2.02 0 0 0 1.944.081l1.986-1.033a1.73 1.73 0 0 1-.166-.729zM121.207 72.459V52.277a2.545 2.545 0 0 1 2.553-2.538h-4.727a2.545 2.545 0 0 0-2.553 2.538v20.182a2.569 2.569 0 0 0 2.576 2.538h4.728a2.569 2.569 0 0 1-2.577-2.538z",
    opacity: 0.136
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h238v238H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinDespacho);
export default __webpack_public_path__ + "static/media/sin_despacho.b334a3cdf1b608559b175092a3f19e94.svg";
export { ForwardRef as ReactComponent };